<template>
  <CheckoutStep class="h-full">
    <template #header>
      <Stepper />
    </template>
    <template #aside>
      <GiftCardSummary
        v-if="giftCard"
        :assetUrl="giftCard.designAsset.assetUrl"
        :price="giftCard.price"
      />
    </template>
    <div>PaymentStep</div>
    <pre>{{ giftCard }}</pre>
  </CheckoutStep>
</template>

<script setup lang="ts">
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

import CheckoutStep from '~/scopes/checkout/components/CheckoutStep/CheckoutStep.vue'

import GiftCardSummary from '../../components/GiftCardSummary/GiftCardSummary.vue'
import Stepper from '../../components/Stepper/Stepper.vue'

defineProps<{
  giftCard: ApiSpecs['/api/gift-cards/v1/product-page/giftcard/request/:requestId']['GET']['response']
}>()
</script>
